"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setNewData = setNewData;
const defaultValue_1 = require("./defaultValue");
const setData_1 = require("./setData");
const IOptions_1 = require("../WrappedProperty/IOptions");
/**
 * ustawienie danych zgodnie ze schematem
 *
 * @export
 * @param {JSONSchema} schema schemat
 * @param {*} data obiekt reprezentujący dane docelowe
 * @param {*} value dane do zapisu
 * @param {(string | string[])} [path] ścieżka
 * @param {number} [pathIndex=0] indeks na ścieżce (dane wewnętrzne)
 * @param {*} [Vue] konktruktor Vue
 * @param {boolean} [fixArraySize] czy ustawiać nowy rozmiar tablicyw  przypadku tablic
 * @returns {boolean} czy udało się ustawić
 */
function setNewData(schema, data, value, path, pathIndex = 0, options = IOptions_1.defaultOptions, currentPath = '') {
    if (path) {
        if (typeof path === 'string') {
            path = path
                .replace(/\[/g, '.')
                .replace(/\]/g, '')
                .split('.')
                .filter((x) => x);
            pathIndex = 0;
            // mssql path fix
            if (path[pathIndex] == '$') {
                pathIndex++;
            }
        }
        const cpath = path[pathIndex];
        if (cpath) {
            if (schema.type === 'object') {
                const dschema = schema.properties[cpath];
                if (dschema !== undefined) {
                    if (dschema.type === 'object' || dschema.type === 'array') {
                        let data2 = data[cpath];
                        if (data2 === undefined) {
                            data2 = (0, defaultValue_1.defaultValue)(dschema, true, undefined, options, currentPath + '.' + cpath);
                            data[cpath] = data2;
                        }
                        return setNewData(dschema, data2, value, path, pathIndex + 1, options, currentPath + '.' + cpath);
                    }
                    else {
                        return (0, setData_1.setDataValue)(dschema, data, cpath, value);
                    }
                }
                else {
                    return false;
                }
            }
            else if (schema.type === 'array') {
                const dschema = schema.items;
                if (dschema !== undefined) {
                    const index = parseInt(cpath, 10);
                    const data2 = data[index];
                    if (data2 === undefined) {
                        while (data.length < index + 1) {
                            data.push((0, defaultValue_1.defaultValue)(dschema, true, undefined, options, currentPath + '[' + data.length + ']'));
                        }
                        // data2 = data[index];
                    }
                    if (dschema.type === 'array' || dschema.type === 'object') {
                        return setNewData(dschema, data[index], value, path, pathIndex + 1, options);
                    }
                    else {
                        return (0, setData_1.setDataValue)(dschema, data, index, value);
                    }
                }
                else {
                    return false;
                }
            }
            else {
                return false;
            }
        }
    }
    if (schema.type === 'object') {
        return setNewDataObj(schema, data, value, options, currentPath);
    }
    else {
        return setNewDataArray(schema, data, value, options, currentPath);
    }
}
/**
 * ustawia dane tablicowe
 *
 * @param {JSONSchema} schema schemat
 * @param {any[]} destArray docelowa tablica
 * @param {any[]} value nowa wartość
 * @param {*} [Vue] konsktruktor Vue
 * @param {boolean} [fixArraySize] czy ustawić nowy rozmiar tablicy
 * @returns {boolean} czy udało się ustawić
 */
function setNewDataArray(schema, destArray, value, options = IOptions_1.defaultOptions, currentPath = '') {
    if (value === undefined)
        return false;
    if ((value = (0, setData_1.fixType)(schema, value)) === undefined)
        return false;
    const sitems = schema.items;
    let destIndex = 0;
    for (let i = 0; i < value.length; i++) {
        const prevItem = destArray[destIndex];
        let newItem;
        switch (sitems.type) {
            case 'object':
                newItem = prevItem || (0, defaultValue_1.defaultValue)(sitems, true, undefined, options, currentPath + '[' + i + ']');
                if (setNewDataObj(sitems, newItem, value[i], options, currentPath + '[' + i + ']')) {
                    if (newItem != prevItem) {
                        destArray[destIndex] = newItem;
                    }
                    destIndex++;
                }
                break;
            case 'array':
                newItem = prevItem || (0, defaultValue_1.defaultValue)(sitems, true, undefined, options, currentPath + '[' + i + ']');
                if (setNewDataArray(sitems, newItem, value[i], options, currentPath + '[' + i + ']')) {
                    if (newItem != prevItem) {
                        destArray[destIndex] = newItem;
                    }
                    destIndex++;
                }
                break;
            default:
                if ((0, setData_1.setDataValue)(sitems, destArray, destIndex, value[i])) {
                    destIndex++;
                }
                break;
        }
    }
    while (destArray.length > destIndex) {
        destArray.splice(destArray.length - 1, 1);
    }
    return true;
}
/**
 * ustawia dane obiektowe
 *
 * @param {JSONSchema} schema schemat
 * @param {*} parentObject docelowy obiekt
 * @param {*} value nowa wartość
 * @param {*} [Vue] konsktruktor Vue
 * @param {boolean} [fixArraySize] czy ustawić nowy rozmiar tablicy
 * @returns {boolean}czy udało się ustawić
 */
function setNewDataObj(schema, parentObject, value, options = IOptions_1.defaultOptions, currentPath = '') {
    const props = schema.properties;
    if (!props) {
        return false;
    }
    if ((value = (0, setData_1.fixType)(schema, value)) === undefined)
        return false;
    const ppath = currentPath ? currentPath + '.' : currentPath;
    for (const key in props) {
        const pschema = props[key];
        let kvalue = value && value[key];
        const isCalc = !!(pschema.calc && !pschema.calc.when);
        switch (pschema.type) {
            case 'object':
                /*
                if (kvalue === null) {
                  setDataValue(pschema, parentObject, key, null);
                  continue;
                }
                */
                {
                    let nparent = parentObject[key];
                    if (nparent === undefined || nparent === null) {
                        (0, setData_1.setDataValue)(pschema, parentObject, key, (0, defaultValue_1.defaultValue)(pschema, true, undefined, options, ppath + key) || {});
                        nparent = parentObject[key];
                        if (!kvalue)
                            continue;
                    }
                    if (!kvalue) {
                        // tak jak w fix
                        if (isCalc) {
                            break; //nie ustawiaj default
                        }
                        kvalue = (0, defaultValue_1.defaultValue)(pschema, true, undefined, options, ppath + key);
                    }
                    setNewDataObj(pschema, nparent, kvalue, options, ppath + key);
                }
                break;
            case 'array':
                /*
                if (kvalue === null) {
                  setDataValue(pschema, parentObject, key, null);
                  continue;
                }
                */
                {
                    let narray = parentObject[key];
                    if (narray === undefined || narray === null) {
                        parentObject[key] = narray = (0, defaultValue_1.defaultValue)(pschema, true, undefined, options, ppath + key);
                        if (!kvalue)
                            continue;
                    }
                    if (!kvalue) {
                        // tak jak w fix
                        if (isCalc) {
                            break; //nie ustawiaj default
                        }
                        kvalue = (0, defaultValue_1.defaultValue)(pschema, true, undefined, options, ppath + key);
                    }
                    setNewDataArray(pschema, narray, kvalue, options, ppath + key);
                }
                break;
            default:
                if (kvalue === undefined) {
                    if (isCalc && parentObject[key] !== undefined) {
                        break; //nie ustawiaj default
                    }
                    parentObject[key] = (0, defaultValue_1.defaultValue)(pschema, true, undefined, options, ppath + key);
                }
                else {
                    (0, setData_1.setDataValue)(pschema, parentObject, key, kvalue);
                }
                break;
        }
    }
    return true;
}
exports.default = setNewData;
//# sourceMappingURL=setNewData.js.map